import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Content Grid",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/content-grid", (props) => {
  return (
    <div className="w-grid mx-auto flex flex-col gap-7 my-10">
      <EditableText as="p" store="title" className="type-label-xl" placeholder="Optional Title" />
      <div className="w-full flex flex-col gap-5">
        <div className={cn("w-full", !env.admin && "grid grid-cols-1 md:grid-cols-3 gap-x-7 gap-y-10")}>
          <InnerBlocks
            allowedBlocks={["content/content-grid-item"]}
            adminClassName="grid grid-cols-1 md:grid-cols-3 gap-x-7 gap-y-10"
            template={[
              ["content/content-grid-item", {}],
              ["content/content-grid-item", {}],
              ["content/content-grid-item", {}],
              ["content/content-grid-item", {}],
              ["content/content-grid-item", {}],
              ["content/content-grid-item", {}],
            ]}
            orientation="horizontal"
          />
        </div>
      </div>
    </div>
  )
})
